import { render, staticRenderFns } from "./text-image-row.vue?vue&type=template&id=163a75b8&scoped=true&"
import script from "./text-image-row.vue?vue&type=script&lang=js&"
export * from "./text-image-row.vue?vue&type=script&lang=js&"
import style0 from "./text-image-row.vue?vue&type=style&index=0&id=163a75b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163a75b8",
  null
  
)

export default component.exports